import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_VIEWED_STUDY_PORTRAITS_BY_CLASS_ID = gql`
  query GetViewedStudyPortraits($classId: Int!) {
    getViewedJobPortaits(schoolClassID: $classId) {
      id
      title
      visits
      image {
        ...imageFields
      }
    }
  }
  ${ImageFragment}
`;
